import focusableSelectors from "./component-library228.mjs";
import { ref, onMounted, onBeforeUnmount } from "vue";
const focusTrap = (element, event, customEvent = void 0) => {
  if (event.key === "Tab") {
    if (!(element == null ? void 0 : element.value))
      return;
    const currentElement = "$el" in element.value ? element.value.$el : element.value;
    if (!(currentElement == null ? void 0 : currentElement.querySelectorAll))
      return;
    const focusableElements = currentElement.querySelectorAll(focusableSelectors.join(", "));
    if (focusableElements.length === 0)
      return;
    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];
    if (event.type === "keyup") {
      console.error(
        // eslint-disable-next-line max-len
        `Focus trap does not work with "keyup". You'll have to use "keydown", otherwise the focus may be gone outside the Browser.`
      );
    } else {
      if (event.target === lastElement && !event.shiftKey) {
        event.preventDefault();
        firstElement.focus();
      }
      if (event.target === firstElement && event.shiftKey) {
        event.preventDefault();
        lastElement.focus();
      }
    }
  }
  if (customEvent) {
    customEvent(event);
  }
};
const addFocusTrap = (customEvent = void 0) => {
  const trapElement = ref(null);
  const handleKeyEvent = ref((event) => {
    if (!trapElement.value) {
      remove();
      return;
    }
    focusTrap(trapElement, event, customEvent);
  });
  const add = (element) => {
    trapElement.value = element.value;
    document.addEventListener("keydown", handleKeyEvent.value, true);
  };
  const remove = () => {
    document.removeEventListener("keydown", handleKeyEvent.value, true);
  };
  return {
    add,
    remove,
    handleKeyEvent
  };
};
const useFocusTrap = (element) => {
  const trap = addFocusTrap();
  onMounted(() => {
    trap.add(element);
  });
  onBeforeUnmount(() => {
    trap.remove();
  });
  return trap;
};
export {
  addFocusTrap,
  focusTrap,
  useFocusTrap
};
